import React from "react";
import OrderSummary$ from "@deosite/components-new/OrderSummary";
import Button from "@deosite/components-new/buttons/Button";

const OrderSummary = props => <OrderSummary$ {...props} button={<Button />} />;

export default OrderSummary;
